import * as types from './types';
import { createReducer } from '../../utils';

export default createReducer({
  speakers: [],
})({
  [types.SET_SPEAKERS]: (state, action) => ({ ...state, speakers: action.payload }),
});
